import React from 'react';
import Icon from '../commons/icon';
import { Message } from '../commons/message/message';
import './index.scss';

export const MapPoints = () => {
  return (
    <div className="mapPoints_wrapper">
      <div className="mapPoints_header">
        <Message
          tag="p"
          className={'zds-heading-m-highlight'}
          id="store.floorMap.mapPoints.title"
        />
      </div>
      <div className="mapPoints_body">
        <div className="mapPoints_list zds-body-m">
          <div className="mapPoints_listItem">
            <Icon icon="box" />
            <Message tag="p" id="store.floorMap.mapPoints.pickup" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="stairsMech" />
            <Message tag="p" id="store.floorMap.mapPoints.stairsMech" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="fitting" />
            <Message tag="p" id="store.floorMap.mapPoints.fitting" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="elevator" />
            <Message tag="p" id="store.floorMap.mapPoints.elevator" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="stairs" />
            <Message tag="p" id="store.floorMap.mapPoints.stairs" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="checkOut" />
            <Message tag="p" id="store.floorMap.mapPoints.checkOut" />
          </div>
          <div className="mapPoints_listItem">
            <Icon icon="entry" />
            <Message tag="p" id="store.floorMap.mapPoints.entry" />
          </div>
        </div>
      </div>
    </div>
  );
};
